module.exports = __webpack_public_path__ + "img/page-02.aecf0517.png";